'use client';

import { Input } from '@core/ui/primitives/input';
import { InputGroup, InputGroupInput, InputGroupAddon, InputGroupText } from '@core/ui/primitives/input-group';
import { LuTriangleAlert } from 'react-icons/lu';

interface OrganizationIdentityPanelProps {
  name: string;
  slug: string;
  originalSlug: string;
  onNameChange: (val: string) => void;
  onSlugChange: (val: string) => void;
}

export function OrganizationIdentityPanel({
  name,
  slug,
  originalSlug,
  onNameChange,
  onSlugChange,
}: OrganizationIdentityPanelProps) {
  const slugChanged = slug !== originalSlug;

  return (
    <div className='space-y-8 max-w-2xl p-1'>
      <div className='space-y-6'>
        <div className='space-y-2'>
          <label className='text-sm font-medium text-foreground'>Organization Name</label>
          <Input
            value={name}
            onChange={(e) => onNameChange(e.target.value)}
            placeholder='Organization Name'
          />
          <p className='text-xs text-muted-foreground'>
            The display name for your organization.
          </p>
        </div>

        <div className='space-y-2'>
          <label className='text-sm font-medium text-foreground'>Organization Slug</label>
          <InputGroup>
            <InputGroupAddon>
              <InputGroupText>/</InputGroupText>
            </InputGroupAddon>
            <InputGroupInput
              value={slug}
              onChange={(e) => onSlugChange(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
              placeholder='organization-slug'
            />
          </InputGroup>
          <p className='text-xs text-muted-foreground'>
            Used in URLs. Changing this will update all organization URLs.
          </p>
          
          {slugChanged && (
             <div className='mt-3 flex items-start gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3 text-sm text-amber-800 dark:border-amber-900 dark:bg-amber-950/30 dark:text-amber-200'>
               <LuTriangleAlert className='mt-0.5 h-5 w-5 shrink-0 text-amber-600 dark:text-amber-400' />
               <div className='flex-1'>
                 <p className='font-medium'>Warning: Broken Links</p>
                 <p className='mt-1 text-xs opacity-90'>
                   Changing the organization slug will break all existing external links to this organization and its vaults.
                   Internal links will be updated, but bookmarks and shared URLs will stop working.
                 </p>
               </div>
             </div>
          )}
        </div>
      </div>
    </div>
  );
}
